var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("EFFECTIVE DATE")]),_c('h4',[_vm._v("The date the Agreement commences as specified in the Agreement.")])])
}]

export { render, staticRenderFns }